import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import appReducer from './app/appSlice';
import userReducer from './user/userSlice';
import chartReducer from './chart/chartSlice';
import marketReducer from './market/marketSlice';

export const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    chart: chartReducer,
    market: marketReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;